import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	nickName: Yup.string().required().label('NickName'),
});

const Inputs = [
	{
		name: 'nickName',
		label: 'NickName',
		type: 'text',
		value: 'single',
		valueAttr: 'nickName',
	},
];

export { Inputs, validationSchema };
